<template>
  <div class="category-selector">
    <vue-element-loading :active="loadingCategories" />
    <div class="d-block d-sm-none">
      <div class="text-left title mb-3">{{ $t('category_selector.filter_by_category') }}</div>
      <b-button
        v-b-toggle.categories-filters
        variant="secondary-b"
      >{{ selectedCategory && $tradukojTranslate(selectedCategory.name) }}</b-button>
      <b-collapse id="categories-filters" class="mt-2">
        <b-card>
          <ul class="category-list m-0 mb-3 p-0">
            <b-row>
              <b-col cols="12" md="12" v-for="(category, index) in categoryList" :key="index">
                <li class="text-left text-truncate">
                  <router-link
                    :to="categoryRoute(category)"
                    v-bind:class="{ selected: isSelected(category) }"
                    class="pl-4"
                  >{{ $tradukojTranslate(category.name) }}</router-link>
                </li>
              </b-col>
            </b-row>
          </ul>
        </b-card>
      </b-collapse>
    </div>
    <div class="d-none d-sm-block">
      <div class="title mb-3 py-2 text-uppercase">{{ title }}</div>
      <div v-if="backRoute" class="back mb-3 pb-2">
        <router-link :to="backRoute">&lt; {{ $t('category_selector.back') }}</router-link>
      </div>
      <ul class="category-list m-0 mb-3 p-0">
        <li v-for="(category, index) in categoryList" :key="index">
          <router-link
            :to="categoryRoute(category)"
            v-bind:class="{ selected: selectedCategory && (category.uuid == selectedCategory.uuid) }"
            class="pl-4"
          >{{ $tradukojTranslate(category.name) }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
export default {
  name: "category-selector",
  props: {
    categories: {
      type: Array,
      default: undefined,
    },
    groupedCategories: {
      type: Array,
      default: undefined,
    },
    selectedCategory: {
      type: Object,
      default: undefined,
    },
    selectedGroupedCategory: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    loadingCategories() {
      return this.categoryList == undefined;
    },
    categoryList() {
      if (this.selectedGroupedCategory) {
        // Tenemos un grupo de categorías seleccionado
        if (this.selectedGroupedCategory.categories.length > 0) {
          return this.selectedGroupedCategory.categories;
        }
      } else if (this.selectedCategory) {
        // Hemos seleccionado una categoría
        if (this.selectedCategory.subcategories.length > 0) {
          return this.selectedCategory.subcategories;
        } else if (this.parentGroup) {
          return this.parentGroup.categories;
        } else if (this.firstLevelCategory) {
          return this.categories;
        } else if (this.hasParent) {
          return this.selectedCategory.parent.subcategories;
        }
      }
      return this.groupedCategories || this.categories;
    },
    hasParent() {
      return this.selectedCategory && this.selectedCategory.parent != null;
    },
    parentGroup() {
      // Si la categoría seleccionada se encuentra dentro de un grupo,
      // devolvemos ese grupo
      if (this.selectedCategory && this.groupedCategories) {
        return this.groupedCategories.find((gcat) =>
          gcat.categories.find((cat) => cat.uuid === this.selectedCategory.uuid)
        );
      }
      return undefined;
    },
    firstLevelCategory() {
      // Devuelve true si la categoría seleccionada se encuentra entre las categorías
      // pasadas al componente como de primer nivel
      if (this.selectedCategory && this.categories) {
        return this.categories.some(
          (cat) => cat.uuid == this.selectedCategory.uuid
        );
      }
      return false;
    },
    parents() {
      // Devuelve los padres de las categorías del componente
      if (this.categories) {
        return Array.from(
          new Set(
            this.categories
              .filter((cat) => cat.parent != null)
              .map((cat) => cat.parent.uuid)
          )
        );
      }
      return [];
    },
    backRoute() {
      // Si estamos mirando un grupo de categorías, volvemos a listado de grupos
      if (this.selectedGroupedCategory) {
        return this.rootRoute();
      }

      // Si tenemos una categoría, depende de varios factores
      if (this.selectedCategory) {
        /*if (this.groupedCategories) {
          // Estamos usando grupos de categorías
          if (this.parentGroup) {
            // La categoría esta dentro de un grupo, podemos volver al grupo
            return this.categoryRoute(this.parentGroup);
          }
          else {
            // Podemos volver a la categoría padre
            return this.categoryRoute(this.selectedCategory.parent);
          }
        }*/

        // Estamos usando categorías sin agrupar, observamos el árbol de categorías
        if (
          this.parents.length == 1 &&
          this.parents[0] == this.selectedCategory.uuid
        ) {
          // La categoría seleccionada es la categoría raíz, no hay backRoute
          return null;
        } else if (this.parentGroup) {
          // La categoría esta dentro de un grupo, podemos volver al grupo
          return this.categoryRoute(this.parentGroup);
        } else if (this.firstLevelCategory) {
          // La categoría seleccionada esta entre las categorías iniciales,
          // podemos volver al raíz
          return this.rootRoute();
        } else {
          // Podemos volver a la categoría padre
          return this.categoryRoute(this.selectedCategory.parent);
        }
      }
      return null;
    },
    title() {
      if (this.backRoute) {
        var selected = this.selectedGroupedCategory || this.selectedCategory;
        return this.$tradukojTranslate(selected.name);
      } else {
        return this.$t("category_selector.categories");
      }
    },
  },
  methods: {
    categoryRoute(category) {
      var route = {
        name: this.$route.name,
        params: this.$route.params,
        query: Object.assign({}, this.$route.query),
      };

      // quitamos los filtros por categoría para poner los correspondientes
      delete route.query["categoryUuid"];
      delete route.query["groupedCategoryUuid"];

      // filtramos por categoría o por grupo de categorías
      if (category && category.categories) {
        // Si tiene categorías, es un grupo
        route.query.groupedCategoryUuid = category.uuid;
      } else if (category && this.$route.query.categoryUuid != category.uuid) {
        route.query.categoryUuid = category.uuid;
      }

      return route;
    },
    rootRoute() {
      var route = {
        name: this.$route.name,
        params: this.$route.params,
        query: Object.assign({}, this.$route.query),
      };
      if (this.parents.length == 1) {
        // Todas las categorías tienen el mismo padre
        route.query.categoryUuid = this.parents[0];
      } else {
        // Tenemos agrupación de categorías no relacionadas
        delete route.query["categoryUuid"];
        delete route.query["groupedCategoryUuid"];
      }
      return route;
    },
    isSelected(category) {
      var selected = this.selectedGroupedCategory || this.selectedCategory;
      return selected && category.uuid === selected.uuid;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        category_selector: {
          categories: "Categories",
          back: "Back",
          filter_by_category: "Filter by category",
        },
      },
    },
  },
};
</script>


<style scoped lang="scss">
.category-selector {
  border-bottom: 1px solid $grey4-color;
}

.title {
  border-bottom: 1px solid $grey4-color;
  border-top: 1px solid $grey4-color;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}

.back {
  border-bottom: 1px solid $grey4-color;
}

a {
  color: $text-main-color;
}

a:hover {
  color: $text-main-color;
  text-decoration: none;
}

li {
  line-height: 2rem;
  list-style: none;
  text-transform: uppercase;
}

.category-list a {
  background: url("../static/square.png") no-repeat 0% 1px;
}

.category-list a:hover,
.category-list .router-link-exact-active {
  background: url("../static/square_round.png") no-repeat 0% 1px;
}

.category-list a.selected {
  background: url("../static/square_round.png") no-repeat 0% 1px;
}
@include media-breakpoint-down(sm) {
  .category-selector {
    border: 0px;
  }
}
</style>
